import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button";
import {calculateRemSize, maxWidth, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import artboard from "../images/artboard_9.png";
import ebook from "../images/ebook.png";

const ebookPage = "https://nieruchomosci-w-hiszpanii-ebook.rynekpierwotny.pl/";

export const InvestmentOfferEbookSectionSpain = () => {
    const userDevice = useUserDevice();

    return (
        <section css={sectionStyle}>
            <Image width={userDevice.isMobile ? "336px" : "398px"} height={userDevice.isMobile ? "409px" : "485px"} alt="ebook" src={ebook} />
            <div css={contentStyle}>
                <Image src={artboard} alt="artboard_9" width="auto" height="auto" />
                <Text variant="headline_1" as="p" fontFamily="secondary" css={textAlign}>
                    Jak kupić mieszkanie w Hiszpanii?
                </Text>
                <Text variant="body_copy_1" css={textAlign}>
                    Krok po kroku przeprowadzimy Cię do Twojego mieszkania w Hiszpanii! Na początek sprawdź nasz E-book w formie praktycznego przewodnika
                </Text>
                <Button variant="filled_primary" css={maxWidth("200px")} href={ebookPage}>
                    Zobacz E-book
                </Button>
            </div>
        </section>
    );
};

const sectionStyle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: normal;
    background-color: #9bd7ff;
    ${p(4, 4, 0, 4)};
    flex-direction: column-reverse;
    max-width: 332px; // case with small mobile screens

    @media (min-width: ${theme.breakpoints.md}) {
        display: flex;
        align-items: normal;
        justify-content: center;
        flex-direction: row;
        max-width: none;
        width: 100%;
    }
`;

const contentStyle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: normal;
    text-align: center;
    flex-direction: column;
    ${p(4, 1.5, 4, 1.5)};
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        align-items: flex-start;
        flex: 1 1 50%;
        max-width: 730px;
    }
`;

const textAlign = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button";
import {calculateRemSize, maxWidth, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import artboard from "../images/artboard_9.png";
import ebook from "../images/ebook.png";

const ebookPage = "https://nieruchomosci-w-hiszpanii-ebook.rynekpierwotny.pl/";

export const InvestmentOfferEbookSectionSpain = () => {
    const userDevice = useUserDevice();

    return (
        <section css={sectionStyle}>
            <Image width={userDevice.isMobile ? "336px" : "398px"} height={userDevice.isMobile ? "409px" : "485px"} alt="ebook" src={ebook} />
            <div css={contentStyle}>
                <Image src={artboard} alt="artboard_9" width="auto" height="auto" />
                <Text variant="headline_1" as="p" fontFamily="secondary" css={textAlign}>
                    Jak kupić mieszkanie w Hiszpanii?
                </Text>
                <Text variant="body_copy_1" css={textAlign}>
                    Krok po kroku przeprowadzimy Cię do Twojego mieszkania w Hiszpanii! Na początek sprawdź nasz E-book w formie praktycznego przewodnika
                </Text>
                <Button variant="filled_primary" css={maxWidth("200px")} href={ebookPage}>
                    Zobacz E-book
                </Button>
            </div>
        </section>
    );
};

const sectionStyle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: normal;
    background-color: #9bd7ff;
    ${p(4, 4, 0, 4)};
    flex-direction: column-reverse;
    max-width: 332px; // case with small mobile screens

    @media (min-width: ${theme.breakpoints.md}) {
        display: flex;
        align-items: normal;
        justify-content: center;
        flex-direction: row;
        max-width: none;
        width: 100%;
    }
`;

const contentStyle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: normal;
    text-align: center;
    flex-direction: column;
    ${p(4, 1.5, 4, 1.5)};
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        align-items: flex-start;
        flex: 1 1 50%;
        max-width: 730px;
    }
`;

const textAlign = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
    }
`;
